// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2G1CV","description":"PatientConsentPreview_description__1AZs8"};